var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"per-container"},[_c('div',{staticClass:"flexbox-container"},[_c('div',{staticClass:"wrap"},[_c('LoginHeader'),_c('div',{staticClass:"content"},[_c('ContentLeft'),_c('ContentRight')],1)],1)]),_c('div',{staticClass:"bottom"},[_vm._v("产品监制 | 比亚迪汽车产业办")])])
}
var staticRenderFns = []

export { render, staticRenderFns }